export const DateFormat = {
  YYYY_MM_DD: "YYYY-MM-DD",
  MM: "MM",
  DD: "DD",
  DD_MM: "DD_MM",
  HH_MM_SS: "HH:mm:ss",
  DD_MM_YYYY_HH_MM: "DD/MM/YYYY HH:mm",
  HH_MM: "HH:mm",
};

export type DateFormat = (typeof DateFormat)[keyof typeof DateFormat];

export const DateSeparator = {
  HYPHEN: "-",
  SLASH: "/",
};

export type DateSeparator = (typeof DateSeparator)[keyof typeof DateSeparator];

export const formatDate = (
  date: string | Date,
  format: DateFormat = DateFormat.YYYY_MM_DD,
  separator: DateSeparator = DateSeparator.HYPHEN
) => {
  let auxDate: Date;
  if (typeof date === "string") {
    auxDate = new Date(date);
  } else {
    auxDate = date;
  }
  auxDate.toLocaleString();
  let result: string;
  if (format === DateFormat.YYYY_MM_DD) {
    result = auxDate.toISOString().split("T")[0]!;
  } else if (format === DateFormat.MM) {
    result = auxDate.toLocaleString("default", { month: "short" });
  } else if (format === DateFormat.DD) {
    result = auxDate.toLocaleString("default", { day: "numeric" });
  } else if (format === DateFormat.DD_MM) {
    result = auxDate.toLocaleString("default", {
      day: "numeric",
      month: "short",
    });
  } else if (format === DateFormat.HH_MM_SS) {
    result = auxDate.toLocaleString("default", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } else if (format === DateFormat.DD_MM_YYYY_HH_MM) {
    result = auxDate.toLocaleString("default", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (format === DateFormat.HH_MM) {
    result = auxDate.toLocaleString("default", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } else {
    throw new Error("Invalid format");
  }
  if (separator === DateSeparator.SLASH) {
    result = result.replace(/-/g, "/");
  }
  return result;
};

export const isValidDate = (date: Date) => {
  const isInstance = date instanceof Date;
  const isValidTime = !isNaN(date.getTime());
  return isInstance && isValidTime;
};
